import type { EditRegion } from "@/lib/edit/edit-region-registry"

function stamp(el: HTMLElement, c: EditRegion["coords"]): void {
  el.setAttribute("data-cms-collection", c.collection)
  el.setAttribute("data-cms-id", c.id)
  el.setAttribute("data-cms-field", c.field)
  el.setAttribute("data-cms-locale", c.locale)
  el.setAttribute("data-cms-kind", c.kind)
}

/**
 * Inject `data-cms-*` provenance into a region's live DOM client-side, so the
 * inline editor resolves clicks on a byte-clean prod build (no SSR stamps).
 * Every kind stamps the WHOLE region element — it IS the field. (scalar = plain
 * text, html = a `dangerouslySetInnerHTML` div, lexical = a rich-text body
 * edited via the whole-body modal.) Idempotent: bails (0) if already stamped.
 * Returns the stamp count.
 */
export function injectRegionStamps(region: EditRegion): number {
  if (
    region.el.querySelector("[data-cms-collection]") ||
    region.el.hasAttribute("data-cms-collection")
  )
    return 0
  stamp(region.el, region.coords)
  return 1
}
